
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetolonavalataxi() {



    const cardData =
    {
        keyword: ' Pune to Lonavala Taxi',
        heading: 'Prince Cabs: Pune to Lonavala Taxi',
        headingDescription: 'Prince Cabs offers reliable Pune to Lonavala Taxi services, perfect for weekend getaways, family trips, corporate travel, and sightseeing tours. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride to Lonavala, known for its waterfalls, caves, and scenic viewpoints. With professional chauffeurs, flexible timings, and on-time pickups, we make your Pune to Lonavala journey smooth and enjoyable. Travel affordably and conveniently with Prince Cabs’ trusted taxi service from Pune to Lonavala, designed for comfort, safety, and hassle-free travel.',

        top: 'Top Places to Visit in Lonavala with Prince Cabs',

"topPlaces": [
  {
    "title": "Tiger’s Leap",
    "description": "Tiger’s Leap is one of the most popular viewpoints in Lonavala, offering a thrilling 650-meter drop that resembles a tiger leaping into the valley. The spot provides panoramic views of the Sahyadri mountains, valleys, and waterfalls during monsoon. Visitors often enjoy trekking and photography here. Echo Point nearby adds fun with its natural echo phenomenon. The mist and cool breeze make it a favorite among nature lovers. It is a must-visit for adventure seekers and families alike."
  },
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is a famous monsoon attraction in Lonavala, known for its overflowing steps and gushing waters. Tourists flock here to enjoy splashing around in the cool water, especially during rainy season. The dam is surrounded by green hills and provides a lively picnic atmosphere. Street vendors selling hot tea and pakoras add to the experience. Though crowded, it remains a top spot for group outings. The dam offers a fun and refreshing escape from city life."
  },
  {
    "title": "Lonavala Lake",
    "description": "Lonavala Lake, also called Monsoon Lake, is a serene spot located just outside the town. It fills up during the rainy season and creates a beautiful landscape with surrounding greenery. Visitors enjoy boating, bird watching, and leisurely walks along the lake. During monsoon, small waterfalls around the area enhance its charm. The quiet environment makes it perfect for couples and families. It is an ideal spot to relax amidst natural beauty."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic hill fort located between Lonavala and Karjat, famous for its twin fortresses, Shrivardhan and Manaranjan. It is a popular trekking destination offering breathtaking views of the Sahyadris, valleys, and waterfalls. The trek is especially enchanting during monsoon with mist and lush greenery. The fort has caves and ancient structures that fascinate history buffs. Adventure seekers love camping near the fort. It beautifully combines history, adventure, and nature."
  },
  {
    "title": "Karla Caves",
    "description": "The Karla Caves are ancient Buddhist rock-cut caves dating back to the 2nd century BC. The main chaitya hall is one of the largest and best-preserved in India, featuring a massive stupa and intricately carved pillars. The caves also house Buddhist sculptures and inscriptions. Located on a hill, they offer both spiritual and scenic experiences. Devotees also visit the nearby Ekvira Devi Temple. Karla Caves are a must-visit for history, architecture, and spirituality lovers."
  },
  {
    "title": "Bhaja Caves",
    "description": "Bhaja Caves, located near Karla, are another set of ancient Buddhist caves from the 2nd century BC. They feature chaityas, viharas, and beautiful carvings depicting daily life and mythology. The caves also have 14 stupas dedicated to Buddhist monks. Surrounded by lush hills and waterfalls, they are a peaceful retreat for visitors. The site is a popular trek for history enthusiasts and nature lovers. Its simplicity and artistry make it a heritage treasure of Lonavala."
  },
  {
    "title": "Duke’s Nose (Nagphani)",
    "description": "Duke’s Nose, also known as Nagphani due to its snake-like shape, is a famous trekking and rock-climbing spot near Lonavala. The cliff offers panoramic views of the Sahyadri ranges, Khandala ghat, and surrounding valleys. Adventure lovers come here for rappelling, ziplining, and camping. The peak is also popular for sunrise and sunset views. Its thrilling terrain attracts both beginners and experienced trekkers. Duke’s Nose is an adrenaline-filled highlight of Lonavala tourism."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort, meaning ‘Iron Fort,’ is a strong hill fort near Lonavala, built by various dynasties including the Marathas. It is famous for its massive stone walls, gates, and the unique ‘Vinchu Kata’ (scorpion’s tail) structure. The fort offers panoramic views of Pawna Lake and surrounding hills. The trek to the top is easy, making it suitable for beginners. During monsoon, the fort is enveloped in mist, creating a magical ambiance. It is a blend of history and natural beauty."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake, an artificial reservoir formed by the Pawna Dam, is a favorite camping and picnic destination near Lonavala. The lake is surrounded by forts like Lohagad, Tikona, and Tung, adding to its scenic charm. Adventure seekers enjoy camping, bonfires, stargazing, and water activities here. The tranquil waters reflect the beauty of the surrounding mountains. During monsoon, the lake looks especially picturesque. Pawna Lake is ideal for a peaceful getaway close to nature."
  },
  {
    "title": "Imagicaa Theme Park",
    "description": "Located near Khopoli, just a short drive from Lonavala, Imagicaa is India’s premier international-style theme park. It features thrilling rides, water slides, snow parks, and entertainment shows. Popular attractions include Nitro Roller Coaster, Deep Space, and Mr. India ride. Families enjoy both the theme park and Aqua Imagicaa for day-long fun. The park also hosts seasonal parades and live performances. It is the perfect modern complement to Lonavala’s natural and historic charm."
  }
],


"services": [
    {
        "name": "Pune to Lonavala Cab",
        "description": "Book a comfortable and quick cab ride from Pune to Lonavala, perfect for a weekend getaway or a day trip. Our service includes well-maintained vehicles, courteous drivers, and flexible pickup timings. Whether you're visiting with friends or family, we ensure a safe and scenic ride through the Western Ghats."
    },
    {
        "name": "Pune to Lonavala Cab Tour Package",
        "description": "Explore Lonavala’s top attractions like Bhushi Dam, Tiger Point, and Karla Caves with our all-inclusive cab tour package from Pune. Ideal for families and tourists, the package includes round-trip travel, sightseeing stops, and a professional driver to guide your journey comfortably."
    },
    {
        "name": "Pune to Lonavala Taxi Fare",
        "description": "Get affordable and transparent taxi fares for your Pune to Lonavala trip. Our pricing includes fuel, driver allowance, and tolls with no hidden charges. Choose from budget sedans to premium SUVs for your travel needs and enjoy value for money with every ride."
    },
    {
        "name": "Pune to Lonavala Cab Fare",
        "description": "We offer fixed and flexible cab fare options for trips from Pune to Lonavala. Our services are perfect for one-way, same-day return, or extended stays. Get the best rates in town with high-quality service and smooth road travel for individuals and families alike."
    },
    {
        "name": "Pune Airport to Lonavala Cab",
        "description": "Book a direct cab from Pune Airport to Lonavala for a seamless pickup and transfer. Our airport cab service ensures timely arrivals, luggage assistance, and safe travel to your destination in Lonavala, whether it's a hotel, resort, or homestay."
    },
    {
        "name": "Pune to Lonavala Cab Cost",
        "description": "Check competitive cab cost options from Pune to Lonavala with full fare transparency. Our cab cost depends on the vehicle type, travel duration, and trip format (one-way or round-trip), with no surprise fees. Enjoy comfort, reliability, and affordability in one package."
    },
    {
        "name": "Pune to Lonavala Taxi Service",
        "description": "Choose our trusted taxi service from Pune to Lonavala for reliable and safe travel. We provide AC cabs, skilled drivers, and real-time booking confirmation for your convenience. Ideal for tourists, families, and corporate travelers looking for comfort and punctuality."
    },
    {
        "name": "Pune to Lonavala Innova Cab",
        "description": "Travel to Lonavala in a spacious Innova cab, perfect for group travel or family outings. Enjoy premium comfort with ample legroom, luggage space, and air-conditioning. Our Innova Crysta option also offers extra luxury for long scenic drives."
    },
    {
        "name": "Pune to Khandala Cab",
        "description": "Book a cab from Pune to Khandala, Lonavala's scenic twin town, known for its valleys and viewpoints. Our service provides quick and comfortable transfers with trained drivers and clean vehicles. Choose from budget to luxury cabs as per your travel plan."
    },
    {
        "name": "Pune to Khandala Taxi Fare",
        "description": "We offer transparent and budget-friendly taxi fares for trips from Pune to Khandala. Ideal for solo travelers, couples, or families, our service includes fuel, tolls, and driver charges, with the option for one-way or round-trip bookings."
    },
    {
        "name": "Pune to Lonavala Dzire Taxi",
        "description": "Opt for our Swift Dzire taxi for a budget-friendly, fuel-efficient ride from Pune to Lonavala. Perfect for 2–4 passengers, the Dzire offers a comfortable interior, AC, and smooth drive, all at a highly affordable rate with experienced drivers."
    },
    {
        "name": "Pune to Lonavala Round Trip Cab",
        "description": "Plan a full-day or weekend trip with our round trip cab service from Pune to Lonavala. The cab remains with you throughout the day, offering flexibility for sightseeing, dining, and multiple stops. Great for families and groups who want a personalized travel experience."
    },
    {
        "name": "Pune to Lonavala Family Cab",
        "description": "Book a spacious and family-friendly cab from Pune to Lonavala with child-safe features and ample storage space. Our vehicles are perfect for family vacations, offering smooth rides, courteous drivers, and flexible return options to suit your itinerary."
    }
],
"tableData": [
    ["Pune to Lonavala Cab", "Pune to Lonavala Cab Tour Package"],
    ["Pune to Lonavala Taxi Fare", "Pune to Lonavala Cab Fare"],
    ["Pune Airport to Lonavala Cab", "Pune to Lonavala Cab Cost"],
    ["Pune to Lonavala Taxi Service", "Pune to Lonavala Innova Cab"],
    ["Pune to Khandala Cab", "Pune to Khandala Taxi Fare"],
    ["Pune to Lonavala Dzire Taxi", "Pune to Lonavala Round Trip Cab"],
    ["Pune to Lonavala Family Cab", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Trusted Pune to Lonavala Taxi Service",
        "WhyChoosedescription": "Prince Cabs offers a reliable and efficient taxi service from Pune to Lonavala—perfect for weekend getaways, family picnics, romantic drives, or corporate retreats. Whether you're heading to Bhushi Dam, Tiger’s Point, or just escaping the city for a breath of fresh air, we make your trip comfortable, timely, and worry-free."
    },
    {
        "WhyChooseheading": "Comfortable, Clean & Air-Conditioned Cabs",
        "WhyChoosedescription": "Our fleet includes a wide range of well-maintained vehicles including hatchbacks, sedans, and SUVs. Each cab is equipped with air-conditioning, comfortable seating, clean interiors, and enough luggage space. You can enjoy the beautiful 60-70 km drive from Pune to Lonavala in peace, comfort, and style—without the hassles of driving yourself."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Knowledge",
        "WhyChoosedescription": "Our professional drivers are well-versed with the Pune–Lonavala route, expressway exits, and best local spots. They prioritize safety, punctuality, and courteous service—so you can ask for quick detours to viewpoints, local eateries, or hidden gems, and they'll guide you like a local companion throughout your journey."
    },
    {
        "WhyChooseheading": "Flexible One-Way & Round Trip Options",
        "WhyChoosedescription": "Book a one-way drop, round-trip, or even an hourly rental if you want to explore multiple spots in and around Lonavala like Karla Caves, Duke’s Nose, or Khandala. Our flexible booking options are designed to match your plan—be it a half-day visit or a weekend stay—with easy rescheduling and no extra fuss."
    },
    {
        "WhyChooseheading": "Clean, Sanitized & Safe Vehicles for Your Peace of Mind",
        "WhyChoosedescription": "We follow strict cleanliness and hygiene protocols. Every cab is thoroughly sanitized before and after each trip. Our vehicles are regularly serviced, and safety features like seat belts, GPS tracking, and first-aid kits are standard, making your short getaway safe, hygienic, and worry-free."
    },
    {
        "WhyChooseheading": "Upfront Pricing with Zero Hidden Charges",
        "WhyChoosedescription": "Prince Cabs believes in honest, transparent pricing. Your fare is shared upfront with no last-minute surprises or hidden costs. You pay only what you agreed upon—nothing more. Multiple payment options such as UPI, cards, net banking, or cash make transactions easy and secure."
    },
    {
        "WhyChooseheading": "24/7 Support for Smooth Coordination",
        "WhyChoosedescription": "Whether you’re booking early morning, late night, or during peak holiday season, our customer support team is available 24x7 to help with queries, delays, or special requests. We’re always a call or WhatsApp message away to ensure your Pune to Lonavala trip is smooth and enjoyable from start to finish."
    }
]


















    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Lonavala taxi services?',
        answer: 'Yes, Prince Cabs offers reliable and affordable taxi services from Pune to Lonavala, perfect for weekend getaways, day trips, and sightseeing.',
    },
    {
        question: 'What types of taxis are available for the Pune to Lonavala route?',
        answer: 'We provide hatchbacks, sedans, SUVs, and tempo travellers to suit individuals, couples, families, and groups of all sizes.',
    },
    {
        question: 'Is the Pune to Lonavala taxi ride suitable for a same-day return trip?',
        answer: 'Absolutely! Many customers prefer same-day return trips to Lonavala. We offer flexible booking options for one-way, round-trip, and full-day rentals.',
    },
    {
        question: 'Can I customize my Pune to Lonavala trip with stopovers?',
        answer: 'Yes, you can request stopovers at scenic points like Tiger Point, Bhushi Dam, or Lonavala Lake during your trip.',
    },
    {
        question: 'What are the charges for Pune to Lonavala taxi service?',
        answer: 'Pricing depends on vehicle type, trip duration, and travel preferences. Contact Prince Cabs for an accurate and budget-friendly quote.',
    },
    {
        question: 'How do I book a Pune to Lonavala taxi with Prince Cabs?',
        answer: 'You can book easily via our website or by calling our customer service. Provide your travel date and pickup location, and we’ll handle the rest.',
    },
    {
        question: 'Are the taxis clean and safe for travel to hill stations like Lonavala?',
        answer: 'Yes, all our taxis are regularly sanitized, serviced, and driven by experienced drivers who are familiar with hilly terrains.',
    },
];

const testimonials = [
    {
        name: "Mr. Nilesh Pawar",
        position: "Weekend Traveler",
        text: "Our Pune to Lonavala trip with Prince Cabs was fantastic. The driver was courteous, and we enjoyed all the sightseeing spots without any rush.",
        image: "/img/testimonial/testimonial-thumb-lonavala-1.png",
    },
    {
        name: "Ms. Rutuja Gokhale",
        position: "Student",
        text: "Booked a taxi from Pune to Lonavala for a quick getaway. The cab was clean, on time, and the entire ride was super comfortable.",
        image: "/img/testimonial/testimonial-thumb-lonavala-2.png",
    },
];






























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Taxi",
  "image": "https://princecab.com/assets/images/pune-lonavala-taxi.jpg",
  "description": "Book Pune to Lonavala taxi service with Prince Cabs. Affordable and reliable cabs including Innova, Dzire, and family options. Perfect for one-way trips and round trips from Pune Airport and city. 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7000"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-lonavala-taxi"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Lonavala Taxi | Affordable & Reliable Cab Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs provides Pune to Lonavala taxi service with Innova, Dzire, and family cabs. Affordable fares for one-way and round trips including airport transfers. Book online 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Lonavala Cab, Pune to Lonavala Cab Tour Package, Pune to Lonavala Taxi Fare, Pune to Lonavala Cab Fare, Pune Airport to Lonavala Cab, Pune to Lonavala Cab Cost, Pune to Lonavala Taxi Service, Pune to Lonavala Innova Cab, Pune to Khandala Cab, Pune to Khandala Taxi Fare, Pune to Lonavala Dzire Taxi, Pune to Lonavala Round Trip Cab, Pune to Lonavala Family Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/17.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetolonavalataxi;